import * as _ from 'lodash-es';
import { isMember, isOwner } from '../topicPolicyCheck';
import type { AllTopicsTreeListTopic } from '../useAllTopics';

type TopicAccessWarning<Group, Parent> = {
  parent?: Parent;
  groups?: Group[];
} & (
  | {
      groups: Group[];
      level: 'member' | 'owner';
    }
  | {
      parent: Parent;
      level: 'owner' | 'member';
    }
);

function getTopicAccessWarnings(
  topic: AllTopicsTreeListTopic & {
    parent?: AllTopicsTreeListTopic;
  },
  user: { id: string },
): TopicAccessWarning<
  AllTopicsTreeListTopic['ownerGroups'][number],
  AllTopicsTreeListTopic
> | null {
  const inherited = topic.inheritParent ? topic.parent : undefined;
  const matcher = { id: user.id };

  const ownerGroupsUserIn = (topic.ownerGroups || []).filter((t) =>
    _.some(t?.allUsers || [], matcher),
  );

  if (ownerGroupsUserIn.length > 0) {
    return { level: 'owner', groups: ownerGroupsUserIn };
  }

  if (inherited?.__typename === 'Topic' && isOwner(inherited, user)) {
    return { level: 'owner', parent: inherited };
  }

  const memberGroupsUserIn = (topic.memberGroups || []).filter((t) =>
    _.some(t?.allUsers || [], matcher),
  );

  if (memberGroupsUserIn.length > 0) {
    return { level: 'member', groups: memberGroupsUserIn };
  }

  if (inherited?.__typename === 'Topic' && isMember(inherited, user)) {
    return { level: 'member', parent: inherited };
  }

  return null;
}

export default getTopicAccessWarnings;
